// extracted by mini-css-extract-plugin
export default {"container":"rate_container__FHwuX","cover":"rate_cover__zbPwU","title":"rate_title__kJZJA"};